/* tslint:disable */
import { defineMessages } from 'react-intl';

export default defineMessages({
    topMatch: {
        defaultMessage: 'Top events of the day',
        id: 'component.TopMatch.topMatch'
    },
})